import { Anchor } from '@components/Anchor';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IModalWindow } from '@hooks/useModalWindow';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import ILinha from '@model/Linha';
import { IRelatorioConferenciaChipFilter } from '@services/RelatorioService';
import React from 'react';

export type ConferenciaChipTableProps = {
    data: IData<ILinha, IRelatorioConferenciaChipFilter>
    isLoading: boolean
    detalhesModal: IModalWindow
}

export function ConferenciaChipTable ({ data, isLoading, detalhesModal }: ConferenciaChipTableProps) {
    const formatter = useFormatter();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>


                        <TableSortCell fieldName="linhaId">ID</TableSortCell>
                        <TableSortCell fieldName="numeroSemMascara">Número</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraEmpresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraOperadoraNome">Operadora</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((linha, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell><Anchor onClick={data.handleRowFocused(linha, detalhesModal.open)}>{linha.linhaId}</Anchor></TableKeyCell>
                                    <TableCell>{formatter.toCelular(linha.numeroSemMascara)}</TableCell>
                                    <TableCell>{linha.contratoOperadoraEmpresaNome}</TableCell>
                                    <TableCell>{linha.contratoOperadoraOperadoraNome}</TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>
        </TableWrapper>
    )
}